module.exports = __webpack_public_path__ + "static/media/micronic-logo.f4861fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billing-icons/micronic-logo.png
// module id = 1271
// module chunks = 17